<template>
  <div class="page flex-col">
    <div class="flex-col">
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./assets/img/banner.webp"
      />
      <span class="text_7">赋能校园美好生活</span>
      <div class="group_3 flex-row justify-between">
        <div class="group_4 flex-col"></div>
        <div class="group_5 flex-col">
          <span class="text_8">海南鼎言智造商业管理有限公司</span>
          <div class="text-group_1 flex-col justify-between">
            <span class="text_9">总部地址：重庆市璧山区璧泉街道1001号附25号</span>
            <span class="text_10">公司总机：023-41439990</span>
          </div>
          <div class="text-group_2 flex-col justify-between">
            <span class="text_11">联系电话：丁13368156780&nbsp;&nbsp;&nbsp;&nbsp;刘13523356555</span>
            <span class="text_12">联系邮箱：379085456&#64;qq.com</span>
          </div>
          <div class="section_4 flex-row" @click="handleContactUs">
            <div class="image-text_2 flex-row justify-between">
              <span class="text-group_3">联系我们</span>
              <img
                  class="thumbnail_1"
                  referrerpolicy="no-referrer"
                  src="./assets/img/right.webp"
              />
            </div>
          </div>
        </div>
      </div>
<!--      <span class="text_13">在线留言</span>-->
<!--      <div class="text-wrapper_1 flex-row justify-between">-->
<!--        <span class="text_14">您的名字：</span>-->
<!--        <span class="text_15">您的电话：</span>-->
<!--        <span class="text_16">您的邮箱：</span>-->
<!--      </div>-->
<!--      <div class="group_6 flex-row justify-between">-->
<!--        <div class="group_7 flex-col"></div>-->
<!--        <div class="group_8 flex-col"></div>-->
<!--        <div class="group_9 flex-col"></div>-->
<!--      </div>-->
<!--      <span class="text_17">留言内容：</span>-->
<!--      <div class="group_10 flex-col"></div>-->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleContactUs() {
      window.open('https://e7tq2zvbezrppd6n.mikecrm.com/RScCa5q', '_blank');
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
